


















































































































































import Vue from "vue";
import { IUserData } from "../interfaces/dto";

export default Vue.extend({
  name: "TableUsers",

  props: {
    users: {
      type: Array,
      required: true,
    },
    itemsPerPage: {
      type: Number,
    },
  },

  data() {
    return {
      dialog: false,
      search: "",
      headers: [
        {
          text: "Nome",
          align: "start",
          value: "fullName",
        },
        {
          text: "Gênero",
          value: "gender",
        },
        {
          text: "Nascimento",
          value: "birth",
        },
        {
          text: "Ações",
          value: "actions",
          sortable: false,
        },
      ],
      footerConfig: {
        itemsPerPageText: "Resultados por página",
      },
      userInfo: {
        fullName: "",
        title: "",
        gender: "",
        birth: "",
        email: "",
        pictureMedium: "",
        phone: "",
        nationality: "",
        address: "",
        country: "",
        identification: "",
      },
    };
  },

  watch: {
    dialog(val) {
      val || this.closeDialog();
    },
  },

  computed: {
    // Método para colocar o ícone correspondente para o gênero masculino ou feminino de maneira dinâmica
    toggleGenderIcon(): string {
      return this.userInfo.gender === "Feminino" ? "female" : "male";
    },
  },

  methods: {
    viewUserInfo(item: IUserData) {
      // userInfo recebe tudo o que vem de item
      this.userInfo = Object.assign({}, item);
      this.dialog = true;
    },

    closeDialog() {
      this.dialog = false;
    },
  },
});
